module.exports = __webpack_public_path__ + "public/StoreIcon/pswVisible.svg?8287e6b1";